import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import AddIcon from '@mui/icons-material/Add';
import HistoryIcon from '@mui/icons-material/History';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import { useAuth } from '../../context/AuthContext';
import { ProjectTrackerPermissions } from '../../utils/permissions';

const EstimatorApplicationMenuInternal = () => {
  const { userPermissions } = useAuth();
  const navigate = useNavigate();
  const pendingCount = 5;

  const userPermissionNames = useMemo(
    () => userPermissions?.map(p => p.name) || [],
    [userPermissions]
  );

  const menuItems = [
    {
      title: 'New Estimate',
      icon: <AddIcon sx={{ fontSize: 40, color: '#3b82f6' }} />,
      route: '/new-estimate',
      permissions: ProjectTrackerPermissions,
    },
    {
      title: 'Estimate History',
      icon: <HistoryIcon sx={{ fontSize: 40, color: '#3b82f6' }} />,
      route: '/estimate-history',
      permissions: ProjectTrackerPermissions,
    },
    {
      title: 'Edit Pricing',
      icon: <PriceChangeIcon sx={{ fontSize: 40, color: '#3b82f6' }} />,
      route: '/edit-pipe-pricing',
      permissions: ProjectTrackerPermissions,
    },
    {
      title: 'Estimate Management',
      icon: (
        <Badge badgeContent={pendingCount} color="error">
          <ManageAccountsIcon sx={{ fontSize: 40, color: '#3b82f6' }} />
        </Badge>
      ),
      route: '/estimate-management',
      permissions: ProjectTrackerPermissions,
    },
  ];

  const filteredMenuItems = useMemo(() => {
    return menuItems.filter(item =>
      (item.permissions || []).some(p => userPermissionNames.includes(p))
    );
  }, [userPermissionNames]);

  const handleCardClick = (route) => {
    console.log('Navigating to:', route);
    navigate(route);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 3, minHeight: '80vh', maxWidth: '90vw' }}>
      <Typography variant="h5" sx={{ marginBottom: 3, textAlign: 'left' }}>
        Estimator Menu
      </Typography>

      <Grid container spacing={3}>
        {filteredMenuItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                backgroundColor: 'hsl(220, 35%, 97%)',
                border: '1px solid hsla(220, 20%, 80%, 0.4)',
                borderRadius: '8px',
                boxShadow: 0,
                '&:hover': {
                  transform: 'scale(1.05)',
                  transition: 'transform 0.2s',
                },
              }}
            >
              <CardActionArea onClick={() => handleCardClick(item.route)}>
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {item.icon}
                  <Typography variant="h6" sx={{ color: '#111827' }}>
                    {item.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EstimatorApplicationMenuInternal;
